import React from 'react'
import qs from 'qs'
function getURLParams()
{
    return qs.parse(window.location.search, { ignoreQueryPrefix: true })
}

export default getURLParams
